import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import UniversityProgram from './university-program'
import universityProgramFragment from './university-program.fragment'

export const UNIVERSITY_PROGRAM_QUERY = gql`
query UniversityProgram($preview: Boolean, $pageSlug: String) {
  associateProgramCollection(limit: 1, preview: $preview, where: {pageSlug: $pageSlug}) {
    items {
      ${universityProgramFragment}
    }
  }
}
`

export default function UniversityProgramPageWithData(props) {
  const { ssrData, ...restProps } = props
  const variables = {
    pageSlug: '/university-program',
  }

  // If SSR data is provided, render directly
  if (ssrData !== undefined) {
    return ssrData ? (
      <UniversityProgram {...restProps} {...ssrData} />
    ) : <Error statusCode={404} />
  }

  // Fallback to client-side fetching
  return (
    <Query query={UNIVERSITY_PROGRAM_QUERY} variables={variables}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} />
        if (loading) return <LinearProgress color="secondary" />
        const response = data?.associateProgramCollection?.items[0]

        return (response) ? (
          <UniversityProgram {...restProps} {...response} />
        ) : <Error statusCode={404} />
      }}
    </Query>
  )
}

UniversityProgramPageWithData.propTypes = {
  ssrData: PropTypes.object,
}
